// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:59:38

export default {
  "id": "pin-puzzle-love-story",
  "slug": "pin-puzzle-love-story",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/369101fcdb1d4e6996dfe5c720e4bc5c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/369101fcdb1d4e6996dfe5c720e4bc5c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Pin Puzzle Love Story",
      "description": "Are you ready to use your logical mind to save love? In Pin Puzzle-Love Story, you face a series of interesting and challenging levels. Pull pins in the right order to solve puzzles and help couples reunite. Each level is a new Logic puzzle that can only be successfully completed by pulling the right latch!",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "love",
        "story"
      ]
    },
    "zh-CN": {
      "title": "拼图爱情故事",
      "description": "你准备好用你的逻辑思维来拯救爱情了吗？在“拼图解谜-爱情故事”中，你将面临一系列有趣且具有挑战性的关卡。按照正确的顺序拉动图钉，解决谜题，帮助情侣们团聚。每个关卡都是一个新的逻辑谜题，只有拉动正确的卡扣才能成功完成！",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "谜题"
      ],
      "tags": [
        "爱情",
        "故事"
      ]
    },
    "zh-TW": {
      "title": "拼圖愛情故事",
      "description": "你準備好使用你的邏輯思維來拯救愛情了嗎？在「針環拼圖-愛情故事」中，你將面對一系列有趣且挑戰性的關卡。依正確順序拉動針環來解開謎題，幫助情侶們重聚。每個關卡都是一個新的邏輯謎題，只有拉動正確的釣鎖才能成功完成！",
      "instructions": "滑鼠點擊或觸控以遊玩",
      "genres": [
        "謎題"
      ],
      "tags": [
        "愛情",
        "故事"
      ]
    },
    "zh-HK": {
      "title": "釘板拼圖愛情故事",
      "description": "你準備用邏輯思考來拯救愛情嗎？在「釘針遊戲-愛情故事」中，你將面對一連串有趣且挑戰性的關卡。以正確的順序拉動釘針，解開謎題，幫助情侶重逢。每個關卡都是一個新的邏輯謎題，只有拉動正確的釘釋才能成功解開！",
      "instructions": "用滑鼠點擊或觸控玩遊戲",
      "genres": [
        "謎題"
      ],
      "tags": [
        "愛情",
        "故事"
      ]
    },
    "ja": {
      "title": "ピンパズルラブストーリー",
      "description": "ロジカルな思考を使って愛を救う準備はできましたか？Pin Puzzle-Love Storyでは、興味深く挑戦的なレベルの連続に直面します。ピンを正しい順番で引いてパズルを解き、カップルを再会させるのです。各レベルは、正しいリッチを引くことでしか成功できない新しいロジックパズルです！",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "パズル"
      ],
      "tags": [
        "愛の物語"
      ]
    },
    "ko": {
      "title": "핀 퍼즐 로맨스 스토리",
      "description": "준비되셨나요? 로지컬한 사고력을 사용하여 사랑을 구하기 위해 맞나요? Pin Puzzle-Love Story에서는 흥미롭고 도전적인 레벨을 맞대고 있습니다. 올바른 순서로 핀을 당겨 퍼즐을 해결하고 커플을 재결합 도와주세요. 각 레벨은 올바른 댐을 당겨 성공적으로 완료할 수 있는 새로운 로지크 퍼즐입니다!",
      "instructions": "마우스 클릭 또는 탭하여 게임 시작",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "사랑",
        "이야기"
      ]
    },
    "fr": {
      "title": "Pin Puzzle Love Story\nPuzzle à pinceaux Histoire d'amour",
      "description": "Es-tu prêt à utiliser ton esprit logique pour sauver l'amour ? Dans Pin Puzzle-Love Story, tu te confrontes à une série de niveaux intéressants et difficiles. Tire les épingles dans le bon ordre pour résoudre les puzzles et aider les couples à se réunir. Chaque niveau est un nouveau puzzle de logique qui ne peut être résolu avec succès que par le tirage du bon verrou !",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "amour",
        "histoire"
      ]
    }
  }
};
